import React, {useMemo} from 'react';

// services
import {CreditBookApi} from '../../../shared/services/ApiService';

// helpers
import {useTranslation} from 'react-i18next';
import {useQuery} from '@tanstack/react-query';

// components
import {
  CardDetailsSkeleton,
  CardDetailsSubscription,
  CardError,
} from '../../../shared/components';
import {CardNoActiveItem} from '../components';

// styles
import {IconSubscription} from '../DashboardPage-styles';

// types
import {
  CreditBookApiError,
  Subscription,
} from '../../../shared/services/ApiService/types';

/**
 * Fetch the subscriptions
 */
const fetchSubscriptions = async () => {
  const {data} = await CreditBookApi.subscription.getSubscriptions();
  return data;
};

const SectionActiveSubscriptions = () => {
  const {t} = useTranslation();

  const {
    data: subscriptions = [],
    isLoading: subscriptionsLoading,
    error: subscriptionsError,
    isRefetching: subscriptionsRefetching,
  } = useQuery<Subscription[], CreditBookApiError>({
    queryKey: ['getSubscriptions'],
    queryFn: fetchSubscriptions,
    initialData: [],
  });

  const inProgressSubscriptions = useMemo(() => {
    return subscriptions.filter(
      (subscription) => subscription.statusCode === 'IP',
    );
  }, [subscriptions]);

  /**
   * Render the in-progress subscriptions based on the state
   */
  const renderInProgressSubscriptions = () => {
    if (subscriptionsLoading || subscriptionsRefetching) {
      return <CardDetailsSkeleton variant="summary" />;
    }

    if (subscriptionsError) {
      return (
        <CardError
          title={t('subscription_subscriptions')}
          message={subscriptionsError?.response?.data?.errorMessage}
        />
      );
    }

    if (inProgressSubscriptions.length === 0) {
      return (
        <CardNoActiveItem
          title={t('dashboard_noActiveSubscription')}
          icon={<IconSubscription />}
          href="/subscriptions"
        />
      );
    }

    return inProgressSubscriptions.map((subscription) => (
      <CardDetailsSubscription
        key={subscription.id}
        variant="summary"
        subscription={subscription}
      />
    ));
  };

  return <>{renderInProgressSubscriptions()}</>;
};

export default SectionActiveSubscriptions;
